import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';

import RecipientsCard from './RecipientsCard';
import PreviewCard from './PreviewCard';
import SendCTA from './SendCTA';

const SidePanel = ({
  preview,
  coachName,
  body,
  imageUrl,
  isReady,
  isSubmitting,
  onSendClick,
}) => (
  <Stack spacing={2}>
    <RecipientsCard
      count={preview.count}
      loading={preview.loading}
      error={!!preview.error}
      capped={!!preview.capped}
      coachName={coachName}
    />
    <PreviewCard body={body} coachName={coachName} imageUrl={imageUrl} />
    <SendCTA
      isReady={isReady}
      isPreviewLoading={!!preview.loading}
      recipientCount={preview.count}
      isCapped={!!preview.capped}
      isSubmitting={isSubmitting}
      onClick={onSendClick}
    />
  </Stack>
);

SidePanel.propTypes = {
  preview: PropTypes.shape({
    count: PropTypes.number,
    loading: PropTypes.bool,
    error: PropTypes.bool,
    capped: PropTypes.bool,
  }).isRequired,
  coachName: PropTypes.string,
  body: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  isReady: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool,
  onSendClick: PropTypes.func.isRequired,
};

SidePanel.defaultProps = {
  coachName: '',
  imageUrl: '',
  isSubmitting: false,
};

export default SidePanel;
